import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'shortenText'
})
export class ShortenTextTransformPipe implements PipeTransform {

  constructor(private _domSanitizer: DomSanitizer) { }
  transform(value: string, maxLength: number): string {

    let sanitizedValue = this._domSanitizer.sanitize(SecurityContext.HTML, this._domSanitizer.bypassSecurityTrustHtml(value));

    if (sanitizedValue == null)
      return '';

    if (sanitizedValue && sanitizedValue.length <= maxLength) {
      return sanitizedValue; 
    }

    return sanitizedValue.substring(0, maxLength);
  };
}
